interface LayoutWrapperProps {
  children: JSX.Element;
  wrapper?: ({ children }: { children: JSX.Element }) => JSX.Element;
}

const LayoutWrapper = ({ children, wrapper }: LayoutWrapperProps) =>
  wrapper ? wrapper({ children }) : children;

export { LayoutWrapper };
